import { useNavigate } from 'react-router-dom';
import type { OrderStatus } from '@/mocks/profile';

interface Props {
  title: string;
  warehouseLabel: string;
  orders: OrderStatus[];
  warehousePath?: string;
}

const iconBgColors = [
  'bg-primary-50 text-primary-500',
  'bg-orange-50 text-orange-500',
  'bg-blue-50 text-blue-500',
  'bg-green-50 text-green-500',
];

export default function OrderStatus({ title, warehouseLabel, orders, warehousePath }: Props) {
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-2xl p-4 mt-2 shadow-sm border border-background-200/50">
      <div className="flex items-center justify-between mb-5">
        <span className="text-foreground-900 font-bold text-sm">{title}</span>
        <button className="flex items-center gap-0.5 text-foreground-400 text-xs cursor-pointer hover:text-foreground-600 transition-colors" onClick={() => warehousePath && navigate(warehousePath)}>
          {warehouseLabel}
          <i className="ri-arrow-right-s-line text-sm" />
        </button>
      </div>
      <div className="grid grid-cols-4 gap-2">
        {orders.map((item, idx) => (
          <button
            key={item.id}
            className="flex flex-col items-center gap-2 cursor-pointer group"
            aria-label={item.label}
            onClick={() => warehousePath && navigate(`${warehousePath}?tab=${encodeURIComponent(item.label)}`)}
          >
            <div className="relative">
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBgColors[idx % iconBgColors.length]} group-active:scale-95 transition-transform`}>
                <i className={`${item.icon} text-lg`} />
              </div>
              {item.count > 0 && (
                <span className="absolute -top-1 -right-1.5 min-w-[18px] h-[18px] px-1 bg-primary-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center leading-none border-2 border-white shadow-sm">
                  {item.count > 99 ? '99+' : item.count}
                </span>
              )}
            </div>
            <span className="text-foreground-600 text-xs font-medium">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}